import { Flex, List, ListItem, Text } from "@chakra-ui/react";
import React from "react";
import { useGlossary } from "src/hooks/useGlossary";
import { WEGLOT_SKIP_CLASS } from "src/plugins/weglot/constants";
import { RankedSchool } from "src/services/formTemplate/preRankingSection";

type Props = {
  schoolsToRemove: readonly RankedSchool[];
  schoolsToClearSubstatus: readonly RankedSchool[];
  rankingEnabled: boolean;
};
export const RankedSchoolsRemovalConfirmationDialogBody: React.FC<Props> = ({
  schoolsToRemove,
  schoolsToClearSubstatus,
  rankingEnabled,
}) => {
  const { glossary } = useGlossary();
  const leadingText = ["By changing this selection, ", "Also, "];

  return (
    <Flex direction="column" gap={3}>
      {schoolsToRemove.length > 0 && (
        <>
          <Text>
            {leadingText.shift()}
            {glossary`eligibility will change and `}
            <Text as="span" fontWeight="bold">
              {glossary`these schools will be removed`}
            </Text>
            {glossary` from the list, clearing any offers and waitlists where applicable:`}
          </Text>
          <List>
            {schoolsToRemove.map((rankedSchool) => {
              return (
                <SchoolItem
                  key={rankedSchool.school.id}
                  rankedSchool={rankedSchool}
                  rankingEnabled={rankingEnabled}
                />
              );
            })}
          </List>
        </>
      )}
      {schoolsToClearSubstatus.length > 0 && (
        <>
          <Text>
            {leadingText.shift()}
            {glossary`the following schools will have their sub-status cleared. `}
            <Text as="span" fontWeight="bold">
              {glossary`Any offers or waitlists will need to be manually recreated:`}
            </Text>
          </Text>
          <List>
            {schoolsToClearSubstatus.map((rankedSchool) => {
              return (
                <SchoolItem
                  key={rankedSchool.school.id}
                  rankedSchool={rankedSchool}
                  rankingEnabled={rankingEnabled}
                />
              );
            })}
          </List>
        </>
      )}
      <Text fontWeight="bold">Are you sure?</Text>
    </Flex>
  );
};

const SchoolItem = ({
  rankedSchool,
  rankingEnabled,
}: {
  rankedSchool: RankedSchool;
  rankingEnabled: boolean;
}) => {
  return (
    <ListItem
      key={rankedSchool.school.id}
      className={WEGLOT_SKIP_CLASS}
      listStyleType={rankingEnabled ? "none" : "disc"}
      ml={rankingEnabled ? 0 : 4}
    >
      {rankingEnabled && `${rankedSchool.rank + 1} - `}
      {rankedSchool.school.name}
    </ListItem>
  );
};
